import { ChatFixture } from './types';

/**
 * Journey 6 — montage.
 *
 * Wide-screen finale: integrations grid, memory timeline, marketing cards.
 * This fixture is mostly data-shaped — the UI reads these structured payloads
 * and renders the montage grid/timeline.
 */

export const integrations = [
  { id: 'gmail', name: 'Gmail', status: 'connected', lastSync: '2m ago', icon: 'mail' },
  { id: 'calendar', name: 'Calendar', status: 'connected', lastSync: '1m ago', icon: 'calendar' },
  { id: 'docs', name: 'Google Docs', status: 'connected', lastSync: 'just now', icon: 'file-text' },
  { id: 'twilio', name: 'Twilio', status: 'connected', lastSync: '5m ago', icon: 'phone' },
  { id: 'slack', name: 'Slack', status: 'connected', lastSync: '30s ago', icon: 'slack' },
  { id: 'perplexity', name: 'Perplexity', status: 'connected', lastSync: 'just now', icon: 'search' },
];

export const memoryTimeline = [
  {
    ts: '09:14',
    actor: 'Prest0n',
    entry: 'Remembered client preference: all workers-comp demand letters must cite Labor Code § 132a.',
  },
  {
    ts: '09:31',
    actor: 'Prest0n',
    entry: 'Filed intake packet for Hernandez v. Valley Transport — 3 PDFs tagged, 1 translation queued.',
  },
  {
    ts: '10:02',
    actor: 'Fernando',
    entry: '"Never sign a demand letter with the old firm address." — locked into firm policy memory.',
  },
  {
    ts: '10:47',
    actor: 'Prest0n',
    entry: 'Auto-translated follow-up SMS to client (ES). Delivered via Twilio +1 628-444-4018.',
  },
  {
    ts: '11:15',
    actor: 'Prest0n',
    entry: 'Synced 2 new Google Calendar events to case file Hernandez-2024. Conflict check passed.',
  },
];

export const marketingCampaigns = [
  {
    id: 'camp-1',
    title: 'Immigration explainer video — I-589 walkthrough',
    channel: 'YouTube + Instagram Reels',
    status: 'Draft review',
    owner: 'Justin',
  },
  {
    id: 'camp-2',
    title: 'Workers comp retaliation series — 4-part LinkedIn carousel',
    channel: 'LinkedIn',
    status: 'Scheduled · Tue 9am PT',
    owner: 'Prest0n',
  },
  {
    id: 'camp-3',
    title: 'Bilingual SMS outreach — existing WC clients',
    channel: 'Twilio SMS',
    status: 'Live',
    owner: 'Fernando',
  },
];

export const montageFixture: ChatFixture = {
  id: 'montage',
  userQuery: 'Show me everything the firm is running on right now.',
  steps: ['integrations', 'memory', 'marketing', 'complete'],
  chunks: [
    { delta: '', delayMs: 180, event: 'thinking', data: { label: 'Gathering firm state...' } },
    {
      delta: '',
      delayMs: 120,
      event: 'integrations',
      data: { items: integrations },
    },
    {
      delta: '',
      delayMs: 140,
      event: 'memory_timeline',
      data: { items: memoryTimeline },
    },
    {
      delta: '',
      delayMs: 140,
      event: 'marketing',
      data: { items: marketingCampaigns },
    },
    {
      delta:
        'Everything you see above is live, authenticated, and automated. Six integrations. ' +
        'A memory that remembers firm policy. Marketing that ships itself. This is one operator ' +
        "— Prest0n — running your firm alongside you.",
      delayMs: 90,
    },
  ],
};

export default montageFixture;
